import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import neuroLexLogo from '../../../assets/logo/neurolex_logo_new2.png'; // Import the logo
import '../../../styles/components/landing/LandingNavbar.css';

const LandingNavbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home'); // Default to 'home' or current page
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleContactClick = () => {
    // For now, we'll scroll to footer or handle contact
    // You can modify this later for contact functionality
    console.log('Contact clicked');
  };

  const handleNavClick = (section) => {
    setActiveSection(section);
    setIsMobileMenuOpen(false); // Close mobile menu after clicking
    
    // Navigate based on section
    switch(section) {
      case 'how-it-works':
        // Navigate to how it works page or scroll to section
        navigate('/how-it-works');
        break;
      case 'for-professionals':
        navigate('/for-professionals');
        break;
      case 'for-clinics':
        navigate('/for-clinics');
        break;
      case 'partner-clinics':
        navigate('/partner-clinics');
        break;
      default:
        console.log(`Navigate to: ${section}`);
    }
  };

  // You can also determine active section based on current route
  React.useEffect(() => {
    const path = location.pathname;
    if (path === '/how-it-works') {
      setActiveSection('how-it-works');
    } else if (path === '/for-professionals') {
      setActiveSection('for-professionals');
    } else if (path === '/for-clinics') {
      setActiveSection('for-clinics');
    } else if (path === '/partner-clinics') {
      setActiveSection('partner-clinics');
    } else if (path === '/' || path === '/home') {
      setActiveSection('home');
    } else {
      setActiveSection('home'); // Default to home for unknown routes
    }
  }, [location.pathname]);

  return (
    <nav className="landing-navbar">
      <div className="navbar-container">
        {/* Logo Section */}
        <div className="navbar-brand">
          <Link 
            to="/" 
            className={`brand-link ${activeSection === 'home' ? 'active' : ''}`} 
            onClick={() => setActiveSection('home')}
            style={{ position: 'relative' }}
          >
            <div className="brand-icon">
              {/* NEUROLEX actual logo */}
              <img 
                src={neuroLexLogo} 
                alt="NEUROLEX Logo" 
                className="brand-logo-image"
              />
            </div>
            <span className="brand-text">NEUROLEX</span>
          </Link>
        </div>

        {/* Desktop Navigation Menu */}
        <div className="landing-navbar-menu">
          <ul className="landing-nav-links-list">
            <li>
              <button 
                onClick={() => handleNavClick('how-it-works')}
                className={`landing-nav-link-button ${activeSection === 'how-it-works' ? 'landing-nav-active' : ''}`}
              >
                How It Works
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleNavClick('for-professionals')}
                className={`landing-nav-link-button ${activeSection === 'for-professionals' ? 'landing-nav-active' : ''}`}
              >
                For Professionals
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleNavClick('for-clinics')}
                className={`landing-nav-link-button ${activeSection === 'for-clinics' ? 'landing-nav-active' : ''}`}
              >
                For Clinics
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleNavClick('partner-clinics')}
                className={`landing-nav-link-button ${activeSection === 'partner-clinics' ? 'landing-nav-active' : ''}`}
              >
                Our Partner Clinics
              </button>
            </li>
          </ul>
        </div>

        {/* Contact Us Button */}
        <div className="navbar-actions">
          <button 
            onClick={handleContactClick}
            className="contact-button"
          >
            Contact Us
          </button>

          {/* Mobile Menu Toggle */}
          <button 
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`landing-mobile-menu ${isMobileMenuOpen ? 'landing-mobile-active' : ''}`}>
        <ul className="landing-mobile-nav-links-list">
          <li>
            <button 
              onClick={() => handleNavClick('how-it-works')}
              className={`landing-mobile-nav-link-button ${activeSection === 'how-it-works' ? 'landing-mobile-nav-active' : ''}`}
            >
              How It Works
            </button>
          </li>
          <li>
            <button 
              onClick={() => handleNavClick('for-professionals')}
              className={`landing-mobile-nav-link-button ${activeSection === 'for-professionals' ? 'landing-mobile-nav-active' : ''}`}
            >
              For Professionals
            </button>
          </li>
          <li>
            <button 
              onClick={() => handleNavClick('for-clinics')}
              className={`landing-mobile-nav-link-button ${activeSection === 'for-clinics' ? 'landing-mobile-nav-active' : ''}`}
            >
              For Clinics
            </button>
          </li>
          <li>
            <button 
              onClick={() => handleNavClick('partner-clinics')}
              className={`landing-mobile-nav-link-button ${activeSection === 'partner-clinics' ? 'landing-mobile-nav-active' : ''}`}
            >
              Our Partner Clinics
            </button>
          </li>
          <li>
            <button 
              onClick={() => {
                handleContactClick();
                setIsMobileMenuOpen(false);
              }}
              className="landing-mobile-contact-button"
            >
              Contact Us
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default LandingNavbar;